var _defs, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBattleRaceNoText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Asset",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 228.49 229.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2 {\n        fill: url(#D\xE9grad\xE9_sans_nom_29);\n      }\n\n      .cls-3 {\n        fill: url(#D\xE9grad\xE9_sans_nom_39);\n      }\n\n      .cls-4 {\n        fill: url(#D\xE9grad\xE9_sans_nom_29-2);\n      }\n\n      .cls-5 {\n        fill: #13100d;\n        opacity: .5;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 114.31,
    y1: 221.97,
    x2: 114.31,
    y2: 6.66,
    gradientTransform: "translate(-.07 .1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e73629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#e84126"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#ec5f1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#f39013"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#fdd303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_29",
    "data-name": "D\\xE9grad\\xE9 sans nom 29",
    x1: 114.31,
    y1: 228.39,
    x2: 114.31,
    y2: -0.08,
    gradientTransform: "translate(-.07 .1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c0800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#470c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_39",
    "data-name": "D\\xE9grad\\xE9 sans nom 39",
    x1: 114.31,
    y1: 229.34,
    x2: 114.31,
    y2: 110.29,
    gradientTransform: "translate(-.07 .1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_29-2",
    "data-name": "D\\xE9grad\\xE9 sans nom 29",
    x1: 112.65,
    y1: 204.85,
    x2: 112.65,
    y2: 47.16,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_29"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.89,
    y: 6.89,
    width: 214.71,
    height: 214.71,
    rx: 25.68,
    ry: 25.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M13.77,121.14V37.35c0-9.2,7.48-16.68,16.67-16.68h167.58c9.2-.01,16.68,7.47,16.68,16.67v83.79s13.77,0,13.77,0V37.33c0-16.79-13.67-30.45-30.46-30.45H30.45C13.66,6.9,0,20.56,0,37.35v83.79s13.77,0,13.77,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M198.04,228.48H30.46C13.67,228.49.01,214.83.01,198.04V30.46C0,13.67,13.66.01,30.45.01h167.58c16.79-.01,30.45,13.64,30.45,30.43v167.58c.01,16.79-13.64,30.45-30.43,30.45ZM30.45,13.78c-9.2,0-16.68,7.48-16.68,16.68v167.58c.01,9.2,7.5,16.68,16.7,16.68h167.58c9.2-.01,16.68-7.5,16.68-16.7V30.45c-.01-9.2-7.5-16.68-16.7-16.68H30.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.6,156.91v60.67c0,6.54,5.33,11.86,11.86,11.86h167.58c6.54-.01,11.86-5.33,11.86-11.87v-107.03c-92.12-2.38-153.48,22.12-191.3,46.38Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M198.82,47.26c-.06,0-.19,0-.36-.02-.01,0-.02,0-.04,0-.08,0-.18,0-.28-.01-.02,0-.05,0-.07,0-.11,0-.23,0-.36-.01-.03,0-.06,0-.08,0-.14,0-.29,0-.46-.01-.02,0-.04,0-.08,0-.17,0-.35,0-.55-.01-.02,0-.03,0-.04,0-10.82-.22-56.79.99-96.06,34.67-.01,0-28.63-14.04-73.76,22.96,0,0-2.04,6.66,5.46,14.28,0,0,23.92-7.03,38-.24h0c-.56,2.72-.28,8.6,6.82,18.85.07-.07.15-.15.22-.22-6.83,6.65-13.12,13.42-17.38,19.42,0,0-.1,1.15,1.53,3.14,1.63,1.99,2.77,2.11,2.77,2.11,6.68-2.99,14.49-7.78,22.3-13.13-.03.02-.08.05-.1.07,8.67,8.98,14.38,10.4,17.16,10.38h0c3.89,15.13-7.69,37.21-7.69,37.21,6.01,8.85,12.94,8.15,12.94,8.15,45.14-37.01,36.97-67.83,36.97-67.83h-.01c20.15-15.77,32.83-34.72,40.73-51.13,0,0,.01-.02.02-.03.3-.63.59-1.24.88-1.86.03-.06.05-.12.08-.17.28-.61.56-1.22.83-1.83.02-.05.05-.1.07-.16.28-.61.54-1.22.8-1.83.02-.03.03-.06.04-.09,5.52-12.82,8.07-23.47,9.13-28.85h0c.05-.26.09-.5.14-.73,0-.02,0-.05.01-.07.04-.21.08-.41.11-.6,0-.04.01-.08.02-.12.03-.18.06-.34.08-.49.01-.04.02-.09.02-.13.02-.14.05-.28.07-.4,0-.04,0-.08.02-.12.01-.11.04-.22.06-.32,0-.04,0-.08.01-.11.02-.09.03-.17.04-.24,0-.03,0-.06.02-.08,0-.06,0-.11.02-.15,0-.04,0-.06.01-.08,0-.08.02-.13.02-.13,0,0-.01,0-.05,0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattleRaceNoText);
export default __webpack_public_path__ + "static/media/BattleRaceNoText.1d8182c773a77440ef16dff1206628c2.svg";
export { ForwardRef as ReactComponent };